import { render, staticRenderFns } from "./icon-erase.vue?vue&type=template&id=0f8346ce&scoped=true&"
import script from "./icon-erase.vue?vue&type=script&lang=js&"
export * from "./icon-erase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8346ce",
  null
  
)

export default component.exports